import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import Button from '../../wui-button/src';
import Icon from '../../wui-icon/src';
import Modal from './Modal';
var propTypes = {
  title: PropTypes.string,
  keywords: PropTypes.string,
  content: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  show: PropTypes.bool,
  locale: PropTypes.object
};
var defaultProps = {
  // title: "提示信息",
  onOk: function onOk() {},
  onCancel: function onCancel() {},
  //content: "确认要删除吗 ?",
  show: false,
  //keyword: '删除',
  locale: {
    'ok': '确定',
    'gotit': '知道了',
    'cancel': '取消'
  }
};
var iconTypes = {
  success: 'uf-correct',
  info: 'uf-i-c',
  warning: 'uf-exc-t',
  error: 'uf-exc-c',
  default: 'uf-i-c'
};

var AlertDialog = /*#__PURE__*/function (_Component) {
  _inherits(AlertDialog, _Component);

  var _super = _createSuper(AlertDialog);

  function AlertDialog(props) {
    var _this;

    _classCallCheck(this, AlertDialog);

    _this = _super.call(this, props);
    _this.state = {
      show: true
    };
    return _this;
  }

  _createClass(AlertDialog, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          close = _this$props.close,
          title = _this$props.title,
          keyword = _this$props.keyword,
          content = _this$props.content,
          onOk = _this$props.onOk,
          onCancel = _this$props.onCancel,
          locale = _this$props.locale,
          type = _this$props.type,
          zIndex = _this$props.zIndex,
          _this$props$okText = _this$props.okText,
          okText = _this$props$okText === void 0 ? '' : _this$props$okText,
          _this$props$cancelTex = _this$props.cancelText,
          cancelText = _this$props$cancelTex === void 0 ? '' : _this$props$cancelTex,
          getContainer = _this$props.getContainer;
      var iconType = type in iconTypes ? iconTypes[type] : iconTypes.default;
      var isConfirmType = type === 'confirm';
      var keywordTitleHack = title || keyword; //按钮组

      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Modal, {
        show: this.state.show,
        className: "ac-confirm",
        onHide: close,
        getContainer: getContainer,
        draggable: true,
        width: 420,
        header: null,
        zIndex: zIndex || 1000
      }, /*#__PURE__*/React.createElement(Modal.Body, {
        className: "ac-confirm-body"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ac-confirm-body-title"
      }, /*#__PURE__*/React.createElement(Icon, {
        type: iconType,
        className: "ac-confirm-body-title-icon ".concat(isConfirmType ? 'confirm-type' : '')
      }), /*#__PURE__*/React.createElement("span", {
        className: "ac-confirm-body-title-keyword"
      }, keywordTitleHack)), content && /*#__PURE__*/React.createElement("span", {
        className: "ac-confirm-body-content"
      }, content)), /*#__PURE__*/React.createElement(Modal.Footer, {
        className: "ac-confirm-footer"
      }, /*#__PURE__*/React.createElement(Button, {
        colors: "secondary",
        onClick: function onClick() {
          _this2.setState({
            show: false
          });

          onCancel();
        }
      }, cancelText || locale.cancel), /*#__PURE__*/React.createElement(Button, {
        colors: "primary",
        onClick: function onClick() {
          _this2.setState({
            show: false
          });

          onOk();
        }
      }, okText || locale.ok))));
    }
  }]);

  return AlertDialog;
}(Component);

AlertDialog.propTypes = propTypes;
AlertDialog.defaultProps = defaultProps;
export default AlertDialog;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/ConfirmModal.js